import { abTestTest } from '@frontend/web/experiments/tests/ab-test-test';
import { signInGateMainVariant } from '@root/src/web/experiments/tests/sign-in-gate-main-variant';
import { signInGateMainControl } from '@root/src/web/experiments/tests/sign-in-gate-main-control';
import { newsletterMerchUnitLighthouseControl, newsletterMerchUnitLighthouseVariants, } from '@root/src/web/experiments/tests/newsletter-merch-unit-test';
import { remoteRrHeaderLinksTest } from '@root/src/web/experiments/tests/remoteRrHeaderLinksTest';
import { signInGateFakeSocial } from '@root/src/web/experiments/tests/sign-in-gate-fake-social';
export const tests = [
    abTestTest,
    signInGateMainVariant,
    signInGateMainControl,
    newsletterMerchUnitLighthouseControl,
    newsletterMerchUnitLighthouseVariants,
    remoteRrHeaderLinksTest,
    signInGateFakeSocial,
];
